module.exports = __webpack_public_path__ + "static/media/storage.30a2617b.svg";